"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFocusStyles = exports.baseButtonStyles = exports.disabledButtonStyles = void 0;
const styled_components_1 = require("styled-components");
exports.disabledButtonStyles = (0, styled_components_1.css) `
  cursor: not-allowed;
  color: ${({ theme }) => theme.palette.text.disabled};
`;
exports.baseButtonStyles = (0, styled_components_1.css) `
  ${({ theme }) => theme.typography.variants.primary.main};
  cursor: pointer;
  transition: 0.2s ease all;
  border: 0;
  outline: 0;
  text-transform: none;

  span:first-of-type {
    /* This is to make sure the label appears on top of the ripple animation */
    z-index: 1;
  }
`;
exports.defaultFocusStyles = (0, styled_components_1.css) `
  position: relative;

  &.Mui-focusVisible {
    box-shadow: ${({ theme }) => theme.constants.focusBoxShadow};

    &:after {
      position: absolute;
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: ${({ theme }) => `solid 2px ${theme.palette.common.white}`};
    }
  }
`;
//# sourceMappingURL=shared-styles.js.map